import { Component, ViewChild, OnInit, Input, ElementRef } from "@angular/core";
import { FileUploadService } from "@app/shared/services/files/fileUpload.service";

@Component({
  selector: "app-new-mixed-preview-files",
  templateUrl: "./newmixed-preview-file.component.html",
  styleUrls: ["./newmixed-preview-file.component.css"],
})
export class NewMixedPreviewFileComponent implements OnInit {
  @Input("files")
  _files: Array<any> = [];
  src: any;
  currentFile: any;
  index = 0;
  reader = new FileReader();
  @ViewChild("img") img: ElementRef;
  
  // PDF Zoom controls
  zoomLevel = 1.0;
  zoomStep = 0.25;
  minZoom = 0.25;
  maxZoom = 5.0;
  
  constructor(private _FileUploadService: FileUploadService) {}

  set files(fls) {
    this.initComponent(fls);
  }
  ngOnInit() {}

  initComponent(files: any) {
    this._files = files;
    if (this._files && this._files.length) {
      this.openFile();
    } else {
      this.src = null;
      this.currentFile = null;
    }
  }

  openFile() {
    this.currentFile = this._files[this.index];
    if (!this.currentFile) return;
    if (!this.currentFile.id) {
      // for locally uploaded files
      this.reader.onload = (e) => {
        this.src = this.reader.result;
      };
      this.reader.readAsDataURL(this.currentFile);
    } else {
      // get the file url from the database
      var fileName = this.currentFile.name || this.currentFile.fileName;
      if (fileName) {
        this._FileUploadService
          .getPictureUrl(fileName, "trip")
          .subscribe((promise) => {
            this.src = promise.url;
          });
      }
    }
  }

  prev() {
    if (this.index - 1 >= 0) {
      this.index--;
      this.openFile();
    }
  }

  next() {
    if (this.index + 1 < this._files.length) {
      this.index++;
      this.openFile();
    }
  }

  goToLast() {
    this.index = this._files.length - 1;
    this.openFile();
  }

  goToFile(fileId: number) {
    const index = this._files.findIndex((file) => file.id === fileId || file.tempId === fileId);
    if (index >= 0) {
      this.index = index;
      this.openFile();
    }
  }

  fileType(type: string) {
    if (!this.currentFile) return false;
    if (!this.currentFile.type) return false;

    const currentFileType = this.currentFile.type.toLowerCase();
    if (type.includes("pdf") && currentFileType.includes(type)) {
      return true;
    } else if (
      (type.includes("jpeg") && currentFileType.includes(type)) ||
      (type.includes("jpeg") && currentFileType == "image/png") ||
      (type.includes("tiff") && currentFileType == "image/tiff")
    ) {
      return true;
    }
  }

  getFileTypeDisplay(fileType: string): string {
    if (!fileType) {
      return 'Unknown';
    }

    const type = fileType.toLowerCase();
    
    // PDF files
    if (type.includes('pdf')) {
      return 'PDF Document';
    }
    
    // Image files
    if (type.includes('image/')) {
      if (type.includes('jpeg') || type.includes('jpg')) {
        return 'JPEG Image';
      }
      if (type.includes('png')) {
        return 'PNG Image';
      }
      if (type.includes('gif')) {
        return 'GIF Image';
      }
      if (type.includes('bmp')) {
        return 'BMP Image';
      }
      if (type.includes('tiff')) {
        return 'TIFF Image';
      }
      if (type.includes('webp')) {
        return 'WebP Image';
      }
      if (type.includes('svg')) {
        return 'SVG Image';
      }
      return 'Image';
    }
    
    // Document files
    if (type.includes('word') || type.includes('msword') || type.includes('officedocument.wordprocessingml')) {
      return 'Word Document';
    }
    if (type.includes('excel') || type.includes('spreadsheet') || type.includes('officedocument.spreadsheetml')) {
      return 'Excel Spreadsheet';
    }
    if (type.includes('powerpoint') || type.includes('presentation') || type.includes('officedocument.presentationml')) {
      return 'PowerPoint Presentation';
    }
    
    // Text files
    if (type.includes('text/plain')) {
      return 'Text File';
    }
    if (type.includes('text/csv')) {
      return 'CSV File';
    }
    
    // Other common types
    if (type.includes('zip')) {
      return 'ZIP Archive';
    }
    if (type.includes('rar')) {
      return 'RAR Archive';
    }
    if (type.includes('json')) {
      return 'JSON File';
    }
    if (type.includes('xml')) {
      return 'XML File';
    }
    
    // Return the original type if no match found, but make it more readable
    return fileType.split('/').pop()?.toUpperCase() || 'Unknown';
  }

  open() {
    if (this.currentFile) {
      window.open(
        this.fileType("pdf") ? this.src : this.img.nativeElement.src,
        "mywindow",
        "menubar=1, resizable=1, width=700, height=700"
      );
    }
  }

  // Zoom control methods
  zoomIn() {
    if (this.zoomLevel < this.maxZoom) {
      this.zoomLevel = Math.min(this.zoomLevel + this.zoomStep, this.maxZoom);
    }
  }

  zoomOut() {
    if (this.zoomLevel > this.minZoom) {
      this.zoomLevel = Math.max(this.zoomLevel - this.zoomStep, this.minZoom);
    }
  }

  resetZoom() {
    this.zoomLevel = 1.0;
  }

  fitToPage() {
    this.zoomLevel = 1.0;
  }

  getZoomPercentage(): number {
    return Math.round(this.zoomLevel * 100);
  }
}
